import React from 'react'
import { Helmet } from 'react-helmet'
import { Footer } from '../components/Footer'
import Navbar from '../components/Navbar'
import './main.scss'
import useSiteMetadata from './SiteMetadata'
import { withPrefix } from 'gatsby'
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata()
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon.ico`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon.ico`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer title="hello there" />
    </div>
  )
}

export default TemplateWrapper
